module.exports = __webpack_public_path__ + "static/media/ship.50f0f61d.svg";